import FormAdd from './form_add.vue';

export default FormAdd;
